import React from "react";
import { Link } from "react-router-dom";
import { ENGLISH, FRENCH, MODAL_SIZE, NOT_SELECTED } from "../../App.config";
import Backbutton from "../../containers/Common/Backbutton";
import PrefferedLanguageModel from "../../containers/Settings/PrefferedLanguageModal";
import ChangePassSvg from "../../images/change-pass-icon.svg";
import LanguageSvg from "../../images/language-icon.svg";
import ChangePassword from "../../containers/Settings/ChangePassword";
import DisplayEmployeeName from "../../containers/DisplayEmployeeName";

const SettingsComponent = (props) => {
  const modules = [
    {
      count: 1,
      logo: LanguageSvg,
      heading: props.context.t("Setting.Preferred.Language.text"),
      redirectLinkName: props.context.t("Setting.Change.Language.text"),
      details:
        props?.managersDetails?.languagePreference === null ||
          props?.managersDetails?.languagePreference === undefined
          ? NOT_SELECTED
          : props?.managersDetails?.languagePreference
            ? props.context.t("STD-Employer-Statement.form.label.Manager-Language.option-French")
            : props.context.t("STD-Employer-Statement.form.label.Manager-Language.option-English"),
      redirectLink: "",
      //onClick: "openModal"
    },
    {
      count: 2,
      logo: ChangePassSvg,
      heading: props.context.t("Setting.Change.Password.text"),
      redirectLinkName: props.context.t("Setting.Change.text"),
      details: "",
      redirectLink: "",
      //onClick: "openChangePassModal"
    },
  ];

  const openChangePassModal = () => {
    props.openModal(<ChangePassword {...props} />, MODAL_SIZE.MODAL_SM);
  }

  const openModal = () => {
    props.openModal(<PrefferedLanguageModel {...props} />, MODAL_SIZE.MODAL_SM);
  };

  return (
    <div className="Dashboard-service">
      <div className="row">
        <div className="back-btn-outer">

          <Backbutton />
        </div>
      </div>
      <div className="service-box">
        <DisplayEmployeeName context={props.context} />
        <div className="row">
          {modules.map((module) => (
            <div
              key={module.heading}
              className="col-12 col-sm-12 col-md-12 col-lg-4"
            >
              <div className="s-box">
                <div className="srv-img">
                  <img src={module.logo} alt="" />
                </div>
                <h2>{module.heading}</h2>
                <span>{module.details}</span>
                {
                  <div onClick={module.heading == props.context.t("Setting.Preferred.Language.text") ? openModal
                    :
                    module.heading == props.context.t("Setting.Change.Password.text") ? openChangePassModal
                      :
                      ""
                  } className="r-more">
                    {module.redirectLinkName}
                  </div>
                }
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
export default SettingsComponent;
